module.exports = __webpack_public_path__ + "static/media/Government House.f33fa532.jpeg";